import React, { Component } from "react";

// CSS -- reuses the .free-videos/.video card classes defined here.
import "../Home/Home.scss";
import "./FreeVideos.scss";

// Components
import Header from "../../components/Header/Header";
import PageHeader from "../../components/PageHeader/PageHeader";
import Footer from "../../components/Footer/Footer";

// Helper
import { apiFetch, resolveTenant } from "../../Helper/Api";

const properties = require("../../properties.json");

class FreeVideos extends Component {
  state = {
    tenant: null,
    notFound: false,
    lessons: [],
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = properties.site_name + " - Free Videos";
        this.setState({ tenant });
        return apiFetch("/lessons/free", { query: { teacherUserId: tenant.teacherUserId } });
      })
      .then((lessons) => this.setState({ lessons: lessons || [] }))
      .catch(() => this.setState({ notFound: true }));
  }

  render() {
    const { tenant, notFound, lessons } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />
        <PageHeader pageName="Free Videos" />

        <div className="free-videos free-videos-page">
          <div className="container">
            {lessons.length === 0 ? (
              <p className="text-center">No free lessons are available right now.</p>
            ) : (
              <div className="row">
                {lessons.map((lesson) => (
                  <div className="col-md-4" key={lesson.id}>
                    <div className="video">
                      <div className="thumb">
                        {(lesson.thumb || lesson.image) && (
                          <img src={lesson.thumb || lesson.image} alt={lesson.lessonName} />
                        )}
                        <div className="hover-layer">
                          <i className="fas fa-play-circle"></i>
                        </div>
                      </div>
                      <div className="video-title">
                        <h4>{lesson.lessonName}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default FreeVideos;
